import { render, staticRenderFns } from "./FhiryPage.vue?vue&type=template&id=4424df32&scoped=true&"
import script from "./FhiryPage.vue?vue&type=script&lang=js&"
export * from "./FhiryPage.vue?vue&type=script&lang=js&"
import style0 from "./FhiryPage.vue?vue&type=style&index=0&id=4424df32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4424df32",
  null
  
)

export default component.exports